import { render, staticRenderFns } from "./courseExamPage.vue?vue&type=template&id=3da8e6b9&scoped=true"
import script from "./courseExamPage.vue?vue&type=script&lang=js"
export * from "./courseExamPage.vue?vue&type=script&lang=js"
import style0 from "./courseExamPage.vue?vue&type=style&index=0&id=3da8e6b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8e6b9",
  null
  
)

export default component.exports